import {
  BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer
} from "recharts";
import { ProductReport } from "./model/product-report";

export function RankingChart({ data }: { data: ProductReport[] }) {
  const sorted = [...data].sort((a, b) => a.rank - b.rank);

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={sorted} layout="vertical">
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis type="number"  />  {/* smaller = better rank */}
        <YAxis type="category" dataKey="name" width={120} />
        <Tooltip />
        <Bar dataKey="rank" fill="#ffc658" />
      </BarChart>
    </ResponsiveContainer>
  );
}
